const formatter = new Intl.NumberFormat('en-ZA', { style: 'currency', currency: 'ZAR' })

export function formatCurrency(amount: number | string | null | undefined): string {
  const n = typeof amount === 'string' ? parseFloat(amount) : amount
  return formatter.format(typeof n === 'number' && Number.isFinite(n) ? n : 0)
}
